import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Rob, 2026-09-11: "Never ever send someone to a specific challenge." The
 * per-run pages /challenges/<slug>, /challenges/<slug>/welcome and
 * /challenges/<slug>/call-confirmed no longer exist. Links to them are still
 * sitting in inboxes, texts and ads, so each one lands on the single current
 * page for that step. The query string and hash survive so attribution
 * (utm_*, promoCode, gclid) and anchors (#event-details) keep working, and the
 * redirect never asks whether the slug still exists in the database.
 */
export const legacyChallengeRedirectTarget = ({ pathname = '', search = '', hash = '' }) => {
  const trimmed = String(pathname || '').replace(/\/+$/, '');
  const step = /\/challenges\/[^/]+\/(welcome|call-confirmed)$/.exec(trimmed)?.[1];
  const target = step ? `/challenges/${step}` : '/challenges';
  return `${target}${search || ''}${hash || ''}`;
};

const ChallengeLegacyRedirect = () => {
  const location = useLocation();
  return <Navigate to={legacyChallengeRedirectTarget(location)} replace />;
};

export default ChallengeLegacyRedirect;
